interface Entry {
  id: string;
  guest_name: string;
  message: string | null;
  emoji: string | null;
  pos_x: number;
  pos_y: number;
  signature_data: string | null;
}

interface Props {
  entry: Entry;
  onClick?: () => void;
}

export default function PhotoSticker({ entry, onClick }: Props) {
  return (
    <div
      className="absolute z-10 cursor-pointer group"
      style={{
        left:      `${Math.min(Math.max(entry.pos_x, 0), 85)}%`,
        top:       `${Math.min(Math.max(entry.pos_y, 0), 85)}%`,
        transform: "translate(-50%, -50%)",
        maxWidth:  "160px",
      }}
      onClick={onClick}
    >
      {/* Bubble */}
      <div
        className="rounded-2xl px-3 py-2 text-xs shadow-lg border border-white/30 backdrop-blur-sm transition-all group-hover:scale-105"
        style={{
          backgroundColor: "rgba(255,255,255,0.92)",
          boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
          minWidth: "80px",
          maxWidth: "160px",
        }}
      >
        <div className="flex items-center gap-1.5 mb-1">
          {entry.emoji && <span className="text-sm leading-none">{entry.emoji}</span>}
          <span className="font-bold text-slate-700 text-[11px] truncate">{entry.guest_name}</span>
        </div>
        {entry.message && (
          <p className="text-slate-500 text-[10px] leading-relaxed line-clamp-3">{entry.message}</p>
        )}
        {entry.signature_data && (
          <div className="mt-1.5 h-8 overflow-hidden rounded-lg bg-slate-50 border border-slate-100">
            <img
              src={entry.signature_data}
              alt="firma"
              className="w-full h-full object-contain"
            />
          </div>
        )}
      </div>
      {/* Pin tail */}
      <div
        className="w-0 h-0 mx-auto"
        style={{
          borderLeft: "5px solid transparent",
          borderRight: "5px solid transparent",
          borderTop: "6px solid rgba(255,255,255,0.92)",
        }}
      />
    </div>
  );
}